<div class="dialog-container">

  <div class="dialog-header">
    <div class="dialog-header-icon">
      <mat-icon>print</mat-icon>
    </div>
    <div class="dialog-header-text">
      <h2 class="dialog-title">{{ 'request_v2.print.dialog_title' | translate }}</h2>
      <p class="dialog-subtitle">{{ 'request_v2.print.dialog_hint' | translate }}</p>
    </div>
    <button type="button" class="close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">

    <!-- Citizen group -->
    <div class="section-group">
      <div class="group-label">{{ 'request_v2.print.group.citizen' | translate }}</div>
      <div class="section-row"
           *ngFor="let section of citizenSections"
           [class.deselected]="!section.selected"
           [class.row-disabled]="section.disabled"
           (click)="toggleByKey(section.key)">
        <mat-checkbox
          [checked]="section.selected"
          [disabled]="section.disabled"
          (change)="toggleByKey(section.key)"
          (click)="$event.stopPropagation()">
        </mat-checkbox>
        <span class="section-label">{{ section.label }}</span>
        <span class="empty-badge" *ngIf="section.disabled">{{ 'request_v2.print.empty' | translate }}</span>
      </div>
    </div>

    <!-- Internal group -->
    <div class="section-group">
      <div class="group-label">{{ 'request_v2.print.group.internal' | translate }}</div>
      <div class="section-row"
           *ngFor="let section of internalSections"
           [class.deselected]="!section.selected"
           [class.row-disabled]="section.disabled"
           (click)="toggleByKey(section.key)">
        <mat-checkbox
          [checked]="section.selected"
          [disabled]="section.disabled"
          (change)="toggleByKey(section.key)"
          (click)="$event.stopPropagation()">
        </mat-checkbox>
        <span class="section-label">{{ section.label }}</span>
        <span class="empty-badge" *ngIf="section.disabled">{{ 'request_v2.print.empty' | translate }}</span>
      </div>
    </div>

    <!-- Photos group -->
    <div class="section-group" *ngIf="photosSection as section">
      <div class="group-label">{{ 'request_v2.print.group.photos' | translate }}</div>
      <div class="section-row"
           [class.deselected]="!section.selected"
           [class.row-disabled]="section.disabled"
           (click)="toggleByKey(section.key)">
        <mat-checkbox
          [checked]="section.selected"
          [disabled]="section.disabled"
          (change)="toggleByKey(section.key)"
          (click)="$event.stopPropagation()">
        </mat-checkbox>
        <span class="section-label">{{ section.label }}</span>
        <span class="photos-count" *ngIf="!section.disabled">
          {{ 'request_v2.print.photos.selected_count' | translate: { count: selectedPhotos.length, total: photos.length } }}
        </span>
        <span class="empty-badge" *ngIf="section.disabled">{{ 'request_v2.print.empty' | translate }}</span>
      </div>

      <div class="photos-picker" *ngIf="section.selected">
        <ng-container *ngFor="let group of photoGroups">
          <ng-container *ngIf="group.photos.length">
            <div class="photos-sublabel">
              <mat-checkbox labelPosition="before"
                            [checked]="isGroupSelected(group)"
                            [indeterminate]="isGroupPartlySelected(group)"
                            (change)="togglePhotoGroup(group)">
                {{ group.label | translate }}
              </mat-checkbox>
            </div>
            <div class="photos-grid">
              <div class="photo-tile"
                   *ngFor="let photo of group.photos"
                   role="checkbox"
                   tabindex="0"
                   [attr.aria-checked]="photo.selected"
                   [attr.aria-label]="photo.name"
                   [title]="photo.name"
                   [class.deselected]="!photo.selected"
                   (click)="togglePhoto(photo)"
                   (keydown.enter)="togglePhoto(photo)"
                   (keydown.space)="$event.preventDefault(); togglePhoto(photo)">
                <img [src]="photo.url" [alt]="photo.name" loading="lazy">
                <mat-checkbox class="photo-check"
                              [checked]="photo.selected"
                              tabindex="-1"
                              aria-hidden="true">
                </mat-checkbox>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

  </div>

  <div class="dialog-footer">
    <button type="button" class="btn-cancel" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="btn-print" (click)="print()" [disabled]="selectedCount === 0">
      <mat-icon>print</mat-icon>
      {{ 'common.print' | translate }}
    </button>
  </div>

</div>
